var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhatIsBlockchain(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15,
    height: 14.928,
    viewBox: "0 0 15 14.928",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill-rule:evenodd;fill:url(#a);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#074673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41a1c8"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -0.072)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M7.674,1.043a.469.469,0,0,0-.349,0L1.731,3.281,7.5,5.588l5.769-2.307Zm6.389,2.931L7.969,6.412v7.427L14.063,11.4V3.975ZM7.031,13.839V6.411L.938,3.974V11.4L7.032,13.84ZM6.978.172a1.406,1.406,0,0,1,1.044,0L14.7,2.846a.469.469,0,0,1,.3.435V11.4a.938.938,0,0,1-.59.87L7.674,14.966a.469.469,0,0,1-.349,0L.591,12.272A.938.938,0,0,1,0,11.4V3.281a.469.469,0,0,1,.294-.435Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatIsBlockchain);
export default __webpack_public_path__ + "static/media/whatIsBlockchain.9b482c3e6ad53fa6b6550a074f72ea73.svg";
export { ForwardRef as ReactComponent };